import { PostMessageHandler, consoleLogger } from '@gongxigames/framework/core';
import { BetmgmMessage, BetmgmAPIMessage } from '@gongxigames/framework/integrations/betmgm/types';
import { BottomPanelEvents, FlowModuleEvents, LogicEvents } from '@gongxigames/framework/slot';
import { strictUiEmitter } from '@gongxigames/framework/slotV2/globals';

export class BetmgmPostMessageHandler extends PostMessageHandler<BetmgmAPIMessage> {
    private receiveMessageListener?: (e: MessageEvent) => void;

    protected setupEvents(): void {
        this.on('General.Game.SYSTEM_INITIALIZED', this.onGameLoadingStarted.bind(this));
        this.on('General.Game.SOFT_RELOAD', this.removeListeners.bind(this));
        this.on('General.Game.INITIALIZED', this.onGameLoadingEnded.bind(this));

        this.on(LogicEvents.ROUND_START, this.onRoundStart.bind(this));
        this.on(FlowModuleEvents.ROUND_ENDED, this.onRoundEnded.bind(this));

        this.on(BottomPanelEvents.CASHIER_CLICKED, this.onShowQuickDeposit.bind(this));
        strictUiEmitter.on('UI.menu.cashierClicked', this.onShowQuickDeposit.bind(this));

        this.on(LogicEvents.INVALID_BALANCE, this.onBalanceToLow.bind(this));

        this.on('General.Message.SHOW', this.onNotifyCloseContainer.bind(this));
        this.on('General.ResourcesLoading.ERROR', this.onNotifyCloseContainer.bind(this));
    }

    protected setupListeners(): void {
        if (!this.receiveMessageListener) {
            this.receiveMessageListener = this.receiveMessage.bind(this);
        }

        this._browser.addEventListener('message', this.receiveMessageListener, false);
    }

    protected removeListeners(): void {
        if (this.receiveMessageListener) {
            this._browser.removeEventListener('message', this.receiveMessageListener, false);
        }
    }

    protected receiveMessage(event: MessageEvent<BetmgmMessage>): void {
        const {data} = event;

        switch (data) {
            case 'enableAudio': {
                strictUiEmitter.emit('UI.sounds.enable');
                break;
            }
            case 'disableAudio': {
                strictUiEmitter.emit('UI.sounds.disable');
                break;
            }
            default: {
                consoleLogger.warn('Message is not supported', data);
                break;
            }
        }
    }

    protected onGameLoadingStarted(): void {
        this.postMessage('gameLoadingStarted');
    }

    protected onGameLoadingEnded(): void {
        this.postMessage('gameLoadingEnded');
    }

    protected onRoundStart(): void {
        this.postMessage('gameRoundStarted');
    }

    protected onRoundEnded(): void {
        this.postMessage('gameRoundEnded');
    }

    public onShowQuickDeposit(): void {
        this.postMessage('showQuickDeposit');
    }

    protected onBalanceToLow(): void {
        this.postMessage('balanceTooLow');
    }

    protected onNotifyCloseContainer(): void {
        this.postMessage('notifyCloseContainer');
    }
}